//#region import
import React, { useEffect, useRef, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Box, Divider, Grid, Typography, useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router';
import { Convert, Extension, FnAxios, FnDialog, I18n, RouterDOM } from 'utilities/utilities';
import { BtnBack, BtnCancelForm, BtnPreviewForm, BtnSave } from 'components/Button/ButtonAll';
import { EnumSize, I18NextNs } from 'enum/enum';
import { TextBoxItem } from 'components/Input/TextBox';
import HeaderInput from 'components/Input/HeaderInput';
import UploadFile from 'components/Input/UploadFile';
import { ICheckboxItem } from 'components/Input/Checkbox/CheckboxProps';
import TextOption from './TextOption/TextOption';
import { SelectItem } from 'components/Input/Select/SelectItem';
import SwitchFormItem from 'components/Input/Switch';
import { TimePickerItem } from 'components/Input/TimePicker';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import BannerPreview from './BannerPreview/BannerPreview';
import _ from "lodash";
import { CheckBoxItem } from 'components/Input/Checkbox/CheckBoxItem';
import moment from 'moment';
import TimePicker from 'view/Backend/FundPlan/TimePicker';
import { GetMenuPermission } from 'utilities/SystemFunction';
//#endregion

const BannerForm = () => {
    const Router = RouterDOM();
    const onClearFile = useRef(null);
    const fontColor = "rgb(52, 71, 103)";
    const location = useLocation();
    const Layoutmin900 = useMediaQuery('(min-width:900px)');
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const searchParams = location.search;
    const sIDParams = new URLSearchParams(searchParams).get('sID');
    const sID = new URLSearchParams(searchParams).get('sID');
    const [IsEdit, setIsEdit] = useState(false);
    const [IsShowPreview, setIsShowPreview] = useState<boolean>(false);
    const [previewData, setPreviewData] = useState({} as any);
    const [IsTextOption, setIsTextOption] = useState(false);
    const [arrAttachmentList, setarrAttachmentList] = useState([] as any);
    const [DropdownTextPos, setDropdownTextPos] = useState([]);
    const [oDate, setoDate] = useState({ dS_Max: null, dE_Min: null });
    const [oTime, setoTime] = useState({ tS_Max: null, tE_Min: null });
    const [FontColor, setFontColor] = useState([
        {
            displayColorPicker: false,
            defaultColor: "#999999",
            changeColor: "#999999",
            color:
            {
                r: "0",
                g: "9",
                b: "153",
                a: "1"
            },
            nID: "",
            id: 0
        }]);
    const [DropdownFontSize, setDropdownFontSize] = useState([]);
    const [DropdownLinkType, setDropdownLinkType] = useState([]);
    const [IsLinkTo, setIsLinkTo] = useState(false);
    const [isAllDay, setisAllDay] = useState<boolean>(false);
    const [oldText, setOldText] = useState([]);
    const [prevData, setPrevData] = useState({} as any);
    const [sPlacement, setsPlacement] = useState();
    const [arrGallery, setGalleryData] = useState([]);

    const [arrTextOption, setArrTextOption] = useState([
        {
            nID: 1,
            sHeadline: "",
            sHeadlineFont: null,
            sHeadlineColor: null,
            nHeadlineSize: null,
            nTextOptionID: null,
            sTextMode: "N",
        },
    ] as any);

    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: {
            sBannerName: "",
            sDescription: null,
            sHeadline: "",
            isActive: true,
            checkAllday: false
        } as any,
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);


    const onSubmit = () => {
        let data = getBannerForm(false, false).data;
        if (arrAttachmentList.length === 0) {
            return DialogFn.Warning(I18n.SetText('Banner.UnSubmitFile', I18NextNs.translation));
        }
        if (data != null) {
            let nMaxlength = 0;
            arrTextOption.forEach((item) => {
                if (item.sHeadline.length > 100) {
                    nMaxlength++;
                }
            });
            if (nMaxlength > 0) {
                return DialogFn.Warning("ข้อความมีมากกว่า 100 ตัวอักษร");
            }
        }
        let objParam = {
            sID: sIDParams ?? "",
            bannerForm: getBannerForm(false, false).data,
            sLocation: location.pathname
        };

        DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
            DialogFn.BlockUI();
            AxiosFn.Post("BannerControllers/SaveDataBanner",
                objParam, (result) => {
                    DialogFn.UnBlockUI();
                    DialogFn.Success(`บันทึกสำเร็จ`);
                    DialogFn.CloseSubmit()
                    Router.GoToPage("/BannerList");
                }, (err) => {
                    DialogFn.UnBlockUI();
                    if (!err.response) {
                        DialogFn.Warning(err.sMessage);
                    }
                });
        });

    };


    useEffect(() => {
        onLoadData();
        getFormInitial();
        if (sIDParams) {
            getData();
            // form.setValue("isActive", true);
        }
        // form.setValue("checkAllday", false)
    }, [])

    //#region 
    const HandleChangeDate = (val, type) => {
        if (type === "S") {
            form.setValue("dEnd", "")
            setoDate({ ...oDate, dE_Min: val });
        } else if (type === "E") {
            setoDate({ ...oDate, dS_Max: val });
        }
        else {
            form.setValue("dEnd", "")
        }
    }
    //#endregion



    const DefaultDataPicture = () => {

        let data: ICheckboxItem[] = [
            {
                label: "เพิ่มข้อความบนภาพ"
                , value: "1"
            }
        ];
        return data;

    }


    const DefaultDataLink = () => {

        let data: ICheckboxItem[] = [
            {
                label: I18n.SetText(`linkto`, I18NextNs.translation), value: "1"
            }
        ];
        return data;

    }

    const DefaultDataAllDay = () => {

        let data: ICheckboxItem[] = [
            {
                label: I18n.SetText(`alltime`, I18NextNs.translation), value: "1"
            }
        ];
        return data;

    }

    const getFormInitial = () => {
        AxiosFn.Get(`BannerControllers/GetFormInitial`, {}, (result) => {
            setDropdownFontSize(result.lstFontSize);
            setDropdownTextPos(result.lstFontPosition);
            setDropdownLinkType(result.lstDisplayType);
        })
    }


    const getBannerForm = (modeEqual, modepreview) => {
        let oBannerCheck = {
            data: {},
            equal: false,
            preview: {},
        };
        let lstHeadlinePreview = [] as any;

        if (
            arrAttachmentList != null &&
            arrAttachmentList.length !== 0 &&
            IsTextOption
        ) {
            arrTextOption.forEach((item) => {
                //nDataID	nDataTypeID
                // 4	2
                // 5	2
                // 6	2
                let sSize = "0.8em";
                if (item.nHeadlineSize == EnumSize.large) {
                    sSize = "2.5em"
                } else if (item.nHeadlineSize == EnumSize.mid) {
                    sSize = "1.4em"
                }
                let pdata = {
                    nID: item.nID,
                    sHeadline: item.sHeadline.includes("\n") ? item.sHeadline.replace("\n", '<br/>') : item.sHeadline,
                    sHeadlineSize: sSize,
                    sHeadlineColor: item.sHeadlineColor
                };
                lstHeadlinePreview.push(pdata);
            });
        }

        let lstTextOption = arrTextOption;
        if (!modeEqual) {
            if (oldText != null && oldText.length > 0) {
                oldText.forEach((text, i) => {
                    if (
                        lstTextOption.find(
                            (f) => f.nTextOptionID === text.nTextOptionID
                        ) === undefined ||
                        lstTextOption.find((f) => f.nTextOptionID === text.nTextOptionID) ==
                        null
                    ) {
                        text.sTextMode = "D";
                        lstTextOption.push(text);
                    }
                });
            }
        }

        let dataFile = arrAttachmentList;
        // var data
        let dStart = null;
        let dEnd = null;
        if (!modepreview) {
            if (isAllDay) {

                let start = form.getValues("tTimestart") != null ? Convert.DateTimeToString(form.getValues("dDateStart"), "YYYY-MM-DD") + " " + Convert.DateTimeToString(form.getValues("tTimestart"), "HH:mm") : Convert.DateTimeToString(form.getValues("dDateStart"), "YYYY-MM-DD");
                dStart = new Date(start).valueOf();
                dEnd = new Date(start).valueOf();
            } else {
                let start = form.getValues("tTimestart") != null ? Convert.DateTimeToString(form.getValues("dDateStart"), "YYYY-MM-DD") + " " + Convert.DateTimeToString(form.getValues("tTimestart"), "HH:mm") : Convert.DateTimeToString(form.getValues("dDateStart"), "YYYY-MM-DD");
                let end = form.getValues("tTimeend") != null ? Convert.DateTimeToString(form.getValues("dDateEnd"), "YYYY-MM-DD") + " " + Convert.DateTimeToString(form.getValues("tTimeend"), "HH:mm") : Convert.DateTimeToString(form.getValues("dDateEnd"), "YYYY-MM-DD");

                dStart = new Date(start).valueOf();
                dEnd = new Date(end).valueOf();
            }
        }


        let bannerForm = {
            sBannerName: form.getValues("sBannerName"),
            sDescription: form.getValues("sDescription"),
            IsLink: form.getValues("IsLink"),
            IsTextOption: form.getValues("IsTextOption") || form.getValues("IsTextOption") === "1" ? true : false,
            lstHeadlineOption: arrTextOption,
            nStartDate: dStart,
            nEndDate: dEnd,
            IsAllTime: form.getValues("checkAllday"),
            nDisplayType: form.getValues("sTypeShow"),
            nPlacement: sPlacement,
            // sTypeShow: form.getValues("sTypeShow"),
            sLink: form.getValues("sLink"),
            lstFile: dataFile,
            // sPin: form.getValues("sPin"),
            isActive: form.getValues("isActive"),
            //   objTimeData: objDate,
        };
        let previewData = {
            IsLink: form.getValues("IsLink"),
            sLink: form.getValues("sLink"),
            // sTypeShow: DropdownLinkType.find(
            //     (f) => f.value === form.getValues("sTypeShow")
            // )?.sValue2,
            sFileLink: (dataFile || []).map((file) => file.sFileLink)[0],
            sFileType: (dataFile || []).map((file) => file.sFileType)[0],
            lstHeadlineOption: lstHeadlinePreview,
            nAlign: sPlacement,
            nvAlign: sPlacement,
            // sAlign: DropdownTextPos.find(
            //     (f) => f.value === sPlacement
            // ),
            // vAlign: DropdownTextPos.find(
            //     (f) => f.value === sPlacement
            // ),
            IsTextOption: form.getValues("IsTextOption"),
            nLinkTypeShowID: form.getValues("sTypeShow")
        };
        oBannerCheck.data = bannerForm;
        oBannerCheck.preview = previewData;
        oBannerCheck.equal = _.isEqual(bannerForm, prevData);
        return oBannerCheck;
    };

    const CancelForm = () => {
        DialogFn.Submit('คุณต้องการจะล้างข้อมูลทั้งหมด', () => {
            // Object.keys(form.getValues()).forEach((key => {

            setArrTextOption([{
                nID: 1,
                sHeadline: "",
                sHeadlineFont: null,
                sHeadlineColor: null,
                nHeadlineSize: null,
                nTextOptionID: null,
                sTextMode: "N",
            },]);
            setisAllDay(false);
            setIsLinkTo(false);
            setIsTextOption(false);
            form.setValue("sBannerName", null);
            form.setValue("sDescription", "");
            form.setValue("checkAllday", false);
            form.setValue("isActive", true);
            form.setValue("IsLink", false);
            form.setValue("tTimestart", null);
            form.setValue("tTimeend", null);
            form.setValue("dDateStart", null);
            form.setValue("dDateEnd", null);
            form.setValue("IsTextOption", false);
            setoDate({ dS_Max: null, dE_Min: null });
            onClearFile.current(null);
            setarrAttachmentList([]);
            form.reset();
            form.clearErrors();
            // form.reset();
            DialogFn.CloseSubmit();
            // }))
        });
    };

    const getData = () => {
        DialogFn.BlockUI();
        AxiosFn.Get(
            "BannerControllers/GetDataBanner",
            { sID: sIDParams ?? "" },
            (result) => {
                DialogFn.UnBlockUI();
                if (result.isEdit) {
                    form.setValue("sTypeShow", result.bannerForm.nDisplayType);
                    form.setValue("sBannerName", result.bannerForm.sBannerName);
                    form.setValue("sDescription", result.bannerForm.sDescription);
                    form.setValue("IsLink", result.bannerForm.IsLink);
                    form.setValue("sLink", result.bannerForm.sLink);
                    form.setValue("isActive", result.bannerForm.isActive);
                    form.setValue("checkAllday", result.bannerForm.IsAllTime);
                    setisAllDay(result.bannerForm.IsAllTime);
                    if (result.bannerForm.IsAllTime) {
                        let t = new Date(result.bannerForm.nStartDate);
                        form.setValue("tTimestart", t)
                        form.setValue("dDateStart", moment(t))
                    } else {
                        let ts = new Date(result.bannerForm.nStartDate);
                        let te = new Date(result.bannerForm.nEndDate);
                        form.setValue("tTimestart", ts)
                        form.setValue("dDateStart", moment(ts))
                        form.setValue("tTimeend", te)
                        form.setValue("dDateEnd", moment(te))
                    }
                    // form.setValue("sPlacement", result.bannerForm.sPlacement);
                    setPrevData(result.bannerForm);
                    setIsLinkTo(result.bannerForm.IsLink);
                    setIsTextOption(result.bannerForm.IsTextOption);
                    setArrTextOption(result.lstOldHeadlineOption.length > 0 ? result.lstOldHeadlineOption : arrTextOption);
                    setOldText(result.bannerForm.lstHeadlineOption);
                    setsPlacement(result.bannerForm.nPlacement);
                    form.setValue("sPlacement", result.bannerForm.nPlacement)
                    setTimeout(() => {
                        setarrAttachmentList(result.bannerForm.lstFile ?? []);
                        form.setValue("IsTextOption", result.bannerForm.IsTextOption);
                    }, 500);

                }
                setIsEdit(result.isEdit);
            },
            (err) => {
                if (!err.response) {
                    DialogFn.Warning(err.Message);
                }
            }
        ).then(() => {
            DialogFn.UnBlockUI();
        });
    };

    const onLoadData = () => {
        DialogFn.BlockUI();
        AxiosFn.Get("Home/GetHomeData", {}, (res) => {
            DialogFn.UnBlockUI();
            setGalleryData(res.lstGallery ?? [])
        }).then(
            () => {
                DialogFn.UnBlockUI();
            }
        );
    }


    const handleChangeTime = (type, event) => {
        let end = form.getValues("tTimeend") ? moment(form.getValues("tTimeend")).seconds(0).milliseconds(0) : null;
        let start = form.getValues("tTimestart") ? moment(form.getValues("tTimestart")).seconds(0).milliseconds(0) : null;

        if (type === "s") {
            start = moment(event).seconds(0).milliseconds(0);

        } else if (type === "e") {
            end = moment(event).seconds(0).milliseconds(0);
        }

        if (end && start) {
            if (end.isValid() && start.isValid() && start.isAfter(end)) {
                DialogFn.Warning(I18n.SetText("FundPlan.TimeStratOver"), () => {
                    form.setValue(`tTimeend`, null);
                    form.setValue(`tTimestart`, null);
                    end = null;
                    start = null;
                }, () => {
                    form.setValue(`tTimeend`, null);
                    form.setValue(`tTimestart`, null);
                    end = null;
                    start = null;
                });
            }

        }

    }


    return (
        <FormProvider {...form}>
            <BannerPreview
                open={IsShowPreview}
                handleClose={() => setIsShowPreview(false)}
                data={previewData}
                arrGallery={arrGallery}
            />
            <Grid container className="container-form">
                <Grid item xs={12}>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid key='box-banner' item xs={12}>
                            <Box
                                sx={{
                                    color: "rgb(52, 71, 103)",
                                }}
                                className=".Box-content-form"
                            >
                                <TextBoxItem
                                    name="sBannerName"
                                    label={I18n.SetText(`bannername`, I18NextNs.translation)}
                                    maxLength={150}
                                    id={"sBannerName"}
                                    required={true}
                                    type={'text'}
                                    disabled={!isPermission}
                                />
                            </Box>
                        </Grid>

                        <Grid key='box-banner-des' item xs={12}>
                            <Box
                                sx={{
                                    color: "rgb(52, 71, 103)",
                                }}
                                className=".Box-content-form"
                            >
                                <TextBoxItem
                                    name="sDescription"
                                    label={I18n.SetText(`description`, I18NextNs.translation)}
                                    maxLength={150}
                                    id={"sDescription"}
                                    required={false}
                                    type={'text'}
                                    disabled={!isPermission}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container gap={2} sx={{ alignItems: "center" }}>
                        <Grid item xs={12}>
                            <HeaderInput
                                required
                                text={I18n.SetText(`bannerpic`, I18NextNs.translation)}
                            />
                            <Divider />
                        </Grid>
                        <Grid item md={12} sx={{ justifyContent: "flex-start" }}>

                            <Grid item sx={{ display: 'flex', flexDirection: "column" }}>
                                <UploadFile
                                    id="sDocFile_Banner"
                                    name={"arrBannerFile"}
                                    key={"sDocFile_Banner"}
                                    IsDrag={true}
                                    arrFile={arrAttachmentList}
                                    setarrFile={setarrAttachmentList}
                                    IsFolder={false}
                                    IsMultiple={false}
                                    Extension={[...Extension.Image]}
                                    nLimitFile={10}
                                    sLimitFile={"MB"}
                                    onClearFile={onClearFile}
                                    modeDisplay={"gallery"}
                                    sFolderTemp={"Review"}
                                    IsDragDrop={false}
                                    IsCrop={false}
                                    sPositionText={"right"}
                                    nRecommendWidth={1440}
                                    nRecommendHeight={660}
                                    required={true}
                                    disabled={!isPermission}
                                />
                            </Grid>

                        </Grid>

                    </Grid>

                    <Grid container spacing={2} sx={{ mt: 2 }}>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12} sx={{ display: arrAttachmentList.length === 0 ? "none" : "" }}>
                                    <HeaderInput
                                        required={IsTextOption}
                                        text={"เพิ่มข้อความบนภาพ"}
                                    />
                                    <Divider />
                                </Grid>
                                <Grid item xs={12}>
                                    <CheckBoxItem
                                        name={'IsTextOption'}
                                        disabled={!isPermission}
                                        id={'IsTextOption'}
                                        required={false}
                                        onChange={(value) => {
                                            setIsTextOption(value);
                                        }}
                                        options={DefaultDataPicture()} />
                                </Grid>
                                <TextOption
                                    arrTextOption={arrTextOption}
                                    setArrTextOption={setArrTextOption}
                                    IsTextOption={IsTextOption}
                                    FontColor={FontColor}
                                    setFontColor={setFontColor}
                                    DropdownFontSize={DropdownFontSize}
                                    DropdownTextPos={DropdownTextPos}
                                    IsView={false}
                                    sPlacement={sPlacement}
                                    setsPlacement={setsPlacement}
                                    IsDisabled={!isPermission}
                                />
                            </Grid>
                        </Grid>
                        {/* Link To */}
                        <Grid item xs={12}>
                            <HeaderInput
                                required={IsLinkTo}
                                text={"ลิงก์ไปยัง"}
                            />
                            <Divider />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <CheckBoxItem
                                        name={'IsLink'}
                                        disabled={!isPermission}
                                        id={'IsLink'}
                                        required={false}
                                        onChange={(value) => {
                                            setIsLinkTo(value);
                                        }}
                                        options={DefaultDataLink()} />
                                    {IsLinkTo && <Divider />}
                                </Grid>
                                <Grid
                                    container
                                    spacing={2}
                                    sx={{
                                        border: "1px solid #f4f4f4",
                                        margin: "0.5rem",
                                        pr: 1.5,
                                        pb: 1.5,
                                        display: IsLinkTo ? "flex" : "none",
                                        width: "100%"
                                    }}
                                >
                                    <Grid item xs={12}>
                                        <HeaderInput text={I18n.SetText(`typeshow`, I18NextNs.translation)} required />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box
                                            sx={{
                                                color: fontColor,
                                            }}
                                            className="Box-content-form"
                                        >
                                            <SelectItem
                                                id={"sTypeShow"}
                                                name={"sTypeShow"}
                                                label={
                                                    "-- " + I18n.SetText(`select`, I18NextNs.translation) + " " + I18n.SetText(`typeshow`, I18NextNs.translation) + " --"
                                                }
                                                required={IsLinkTo}
                                                disabled={!isPermission}
                                                options={DropdownLinkType}

                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}></Grid>
                                    <Grid item xs={8}>
                                        <Box
                                            sx={{
                                                color: fontColor,
                                            }}
                                            className="Box-content-form"
                                        >
                                            <TextBoxItem
                                                name="sLink"
                                                label={I18n.SetText(`urlpath`, I18NextNs.translation)}
                                                disabled={!isPermission}
                                                maxLength={150}
                                                IsShrink={false}
                                                type='text'
                                                required={IsLinkTo}
                                            />
                                            <HeaderInput subtext='คำแนะนำ : กรุณาระบุเป็นเว็บไซต์เต็ม เช่น https://www.google.com/' text={''} />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* End Link To */}

                        {/* Date */}
                        <Grid item xs={12}>
                            <HeaderInput
                                required
                                text={"กำหนดวัน และเวลาในการแสดงผล"}
                            />
                            <Divider />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container gap={Layoutmin900 ? 3 : 2} justifyContent={"flex-start"}>
                                <Grid item xs={12} md={6}>
                                    <Grid container spacing={2} justifyContent={"space-between"}>
                                        <Grid item md={"auto"}>
                                            <DatePickerItem
                                                label={`${I18n.SetText("startdate")}`}
                                                id={"dDateStart"}
                                                name={'dDateStart'}
                                                maxDate={oDate.dS_Max}
                                                onChange={e => HandleChangeDate(e, "S")}
                                                required={true}
                                                fullWidth
                                                disabled={!isPermission}
                                                IsShowMessageError={false}
                                                IsDisablePortal={true}
                                            // defaultCalendarMonth={null}
                                            ></DatePickerItem>
                                        </Grid>
                                        <Grid item md={"auto"}>
                                            <TimePicker
                                                name={"tTimestart"}
                                                label={"เวลาเริ่มต้น"}
                                                required={true}
                                                disabled={!isPermission}
                                                icon={"pi pi-clock"}
                                                iconPosition="right"
                                                showIcon={true}
                                                onChange={(e) => {
                                                    handleChangeTime("s", e);
                                                }}
                                            />
                                        </Grid>
                                    </Grid>


                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Grid container spacing={2} justifyContent={"space-between"}>
                                        <Grid item md={"auto"}>
                                            <DatePickerItem
                                                label={`${I18n.SetText("enddate")}`}
                                                id={"dDateEnd"}
                                                name={'dDateEnd'}
                                                minDate={oDate.dE_Min}
                                                required={!isAllDay}
                                                disabled={isAllDay || !isPermission}
                                                onChange={e =>
                                                    HandleChangeDate(e, "E")
                                                }
                                                IsShowMessageError={false}
                                                IsDisablePortal={true}
                                            // defaultCalendarMonth={null}
                                            ></DatePickerItem>
                                        </Grid>
                                        <Grid item md={"auto"}>
                                            <TimePicker
                                                name={"tTimeend"}
                                                label={"เวลาสิ้นสุด"}
                                                onChange={(e) => {
                                                    handleChangeTime("e", e);
                                                }}
                                                required={!isAllDay}
                                                disabled={isAllDay || !isPermission}
                                                icon={"pi pi-clock"}
                                                iconPosition="right"
                                                showIcon={true}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={2} alignItems={'center'}>
                                    <CheckBoxItem
                                        name={'checkAllday'}
                                        disabled={!isPermission}
                                        id={'checkAllday'}
                                        required={false}
                                        onChange={(value) => {
                                            setisAllDay(value);
                                            if (value) {
                                                form.setValue("dDateEnd", null);
                                                form.setValue("tTimeend", null);
                                                setoDate({ dS_Max: null, dE_Min: null });
                                            } else {
                                                form.setValue("dDateEnd", null);
                                                form.setValue("tTimeend", null);
                                                setoDate({ dS_Max: null, dE_Min: form.getValues("dDateStart") });
                                            }
                                        }}
                                        options={DefaultDataAllDay()} />
                                </Grid>


                            </Grid>
                        </Grid>
                        {/* End Date */}
                        <Grid item xs={12} md={12}>
                            <Typography>
                                สถานะ
                                <span style={{ color: "red" }}> * </span>
                            </Typography>
                            <Divider />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <SwitchFormItem
                                name={"isActive"}
                                checkText='ใช้งาน'
                                uncheckText='ไม่ใช้งาน'
                                disabled={!isPermission}
                                width={130}
                                id={"isActive"}
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sx={{ display: "flex", mt: 1.5 }}
                        justifyContent={"space-between"}
                    >
                        <BtnBack
                            onClick={() => {
                                // DialogFn.Submit(I18n.SetText("cancelmsg"), () => {
                                Router.GoToPage("/BannerList");
                                // });
                            }}
                            id={'back'}
                        />
                        <Box sx={{ display: "flex" }}>
                            <BtnPreviewForm
                                onClick={() => {
                                    setPreviewData(getBannerForm(false, true).preview);
                                    setIsShowPreview(true);
                                }}
                                id={'btnpreview'}
                            />
                            <Box sx={{ width: "10px" }}></Box>
                            <BtnCancelForm
                                IsDisabled={!isPermission}
                                onClick={() => {
                                    CancelForm();
                                }}
                                id={'btncancel'}
                            />
                            <Box sx={{ width: "10px" }}></Box>
                            <BtnSave
                                IsDisabled={!isPermission}
                                onClick={form.handleSubmit((e, error) => {
                                    onSubmit();
                                })}
                                id={'btnsave'}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </FormProvider>
    )
}


export default BannerForm;


